export enum DanceManagerSubscriptionTypeEnum {
  FREE = 'FREE',
  UNLIMITED = 'UNLIMITED',
  BRONZE = 'BRONZE',
}
